/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _toLower from 'lodash/toLower';
import _delay from 'lodash/delay';
import _invoke from 'lodash/invoke';
import _head from 'lodash/head';
import _size from 'lodash/size';
import _keys from 'lodash/keys';
import _intersection from 'lodash/intersection';
import _has from 'lodash/has';
import _trim from 'lodash/trim';
import _compact from 'lodash/compact';
import _join from 'lodash/join';
import _replace from 'lodash/replace';
import _trimStart from 'lodash/trimStart';
import _trimEnd from 'lodash/trimEnd';
import _uniq from 'lodash/uniq';
import _includes from 'lodash/includes';
import _pickBy from 'lodash/pickBy';
import _eq from 'lodash/eq';
import _toUpper from 'lodash/toUpper';
import _unset from 'lodash/unset';
import _cloneDeep from 'lodash/cloneDeep';
import _hasIn from 'lodash/hasIn';
import _set from 'lodash/set';
import _sum from 'lodash/sum';
import _subtract from 'lodash/subtract';
import _map from 'lodash/map';
import _isObject from 'lodash/isObject';
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isString from 'lodash/isString';
import _assign from 'lodash/assign';
import _merge from 'lodash/merge';
import { __awaiter, __generator, __decorate } from 'tslib';
import { BindAll } from 'lodash-decorators';
import { map, lastValueFrom, of, concatMap, catchError, filter, TimeoutError } from 'rxjs';
import { ajax, AjaxError } from 'rxjs/ajax';
import { Encryption } from './encryption';
import { Log } from './log';
import { Regulars } from './regulars';

var ENV_TEST = process.env.NODE_ENV === 'test';

var AjaxBasics =
/** @class */
function () {
  /**
   * Ajax
   * @param AjaxConfig
   */
  function AjaxBasics(AjaxConfig) {
    // static CacheSubject = new Subject<string>();

    /**
     * AjaxConfig
     * @type {IAjaxConfig}
     * @memberof AjaxBasics
     */
    this.AjaxConfig = {};
    this.resetConfig(AjaxConfig);
  }

  AjaxBasics_1 = AjaxBasics;
  /**
   * 重置 当前对象配置
   * @param {IAjaxConfig} AjaxConfig
   * @return {*}
   * @memberof AjaxBasics
   */

  AjaxBasics.prototype.resetConfig = function (AjaxConfig) {
    _merge(this.AjaxConfig, AjaxBasics_1.defaultAjaxConfig, AjaxConfig);

    return this;
  };
  /**
   * 重置 默认配置
   * @static
   * @param {IAjaxConfig} AjaxConfig
   * @param {boolean} [merge=true]
   * @memberof AjaxBasics
   */


  AjaxBasics.resetDefault = function (AjaxConfig, merge) {

    _merge(AjaxBasics_1.defaultAjaxConfig, AjaxConfig);
  };
  /**
   * get
   * @param url
   * @param queryParams
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.prototype.get = function (url, body, AjaxConfig) {
    return this.request(_assign({
      url: url,
      body: body,
      method: 'get'
    }, AjaxConfig));
  };
  /**
   * post
   * @param url
   * @param body
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.prototype.post = function (url, body, AjaxConfig) {
    return this.request(_assign({
      url: url,
      body: body,
      method: 'post'
    }, AjaxConfig));
  };
  /**
   * put
   * @param url
   * @param body
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.prototype.put = function (url, body, AjaxConfig) {
    return this.request(_assign({
      url: url,
      body: body,
      method: 'put'
    }, AjaxConfig));
  };
  /**
   * patch
   * @param url
   * @param body
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.prototype.patch = function (url, body, AjaxConfig) {
    return this.request(_assign({
      url: url,
      body: body,
      method: 'patch'
    }, AjaxConfig));
  };
  /**
   * delete
   * @param url
   * @param body
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.prototype["delete"] = function (url, body, AjaxConfig) {
    return this.request(_assign({
      url: url,
      body: body,
      method: 'delete'
    }, AjaxConfig));
  };
  /**
   * request
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.prototype.request = function (AjaxConfig) {
    return AjaxBasics_1.request(_assign({}, this.AjaxConfig, AjaxConfig));
  };
  /**
   * ajax request
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.request = function (AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (_isString(AjaxConfig)) {
          AjaxConfig = {
            url: AjaxConfig,
            method: 'get'
          };
        }

        if (_isEmpty(AjaxConfig)) {
          throw AjaxConfig;
        }

        return [2
        /*return*/
        , AjaxBasics_1.toPromise(AjaxBasics_1.requestObservable(AjaxConfig), AjaxConfig)];
      });
    });
  };
  /**
   * ajax request 缓存模式
   * @param AjaxConfig 默认 cache
   * @returns
   */


  AjaxBasics.requestEnum = function (AjaxConfig, options) {
    return __awaiter(this, void 0, void 0, function () {
      var mapResponse, toLabelValue, mapList, obs;
      return __generator(this, function (_a) {
        if (_isString(AjaxConfig)) {
          AjaxConfig = {
            url: AjaxConfig,
            method: 'get'
          };
        }

        options = _merge({
          separator: ' - '
        }, options);
        mapResponse = map(function (res) {
          if (_isArray(res)) return res;
          if (options === null || options === void 0 ? void 0 : options.responseKey) return _get(res, options.responseKey);
        });

        toLabelValue = function toLabelValue(item, optionKey) {
          if (!_isObject(item)) {
            return item;
          }

          if (_isArray(optionKey)) {
            return _map(optionKey, function (key) {
              return _get(item, key);
            }).join(options.separator);
          }

          return _get(item, optionKey);
        };

        mapList = map(function (data) {
          return _map(data, function (item) {
            return {
              label: toLabelValue(item, options.labelKey),
              value: toLabelValue(item, options.valueKey),
              original: item
            };
          });
        });
        obs = AjaxBasics_1.requestObservable(AjaxConfig).pipe(mapResponse, mapList);
        return [2
        /*return*/
        , AjaxBasics_1.toPromise(obs, AjaxConfig)];
      });
    });
  };
  /**
   * ajax Observable 转换 Promise
   * @param source
   * @returns
   */


  AjaxBasics.toPromise = function (source, AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var request, key, CacheRequest, CacheBeginTime, time;
      return __generator(this, function (_a) {
        // 存在缓存
        if (AjaxConfig === null || AjaxConfig === void 0 ? void 0 : AjaxConfig.cache) {
          // 唯一Key
          key = AjaxBasics_1.getMD5(AjaxConfig);
          CacheRequest = AjaxBasics_1.Cache.get(key);
          CacheBeginTime = _get(CacheRequest, 'CacheBeginTime');
          time = Date.now();

          if (!_isEmpty(CacheRequest) && _subtract(time, _sum([CacheBeginTime, AjaxBasics_1.CacheTime])) < 0) {
            request = AjaxBasics_1.Cache.get(key);
            Log.warning("\u3010 Cache " + key + " " + AjaxConfig.url + " \u3011", {
              AjaxConfig: AjaxConfig,
              request: request,
              Cache: AjaxBasics_1.Cache
            });
          } else {
            // 清理过期缓存
            if (!_isEmpty(CacheRequest)) {
              AjaxBasics_1.Cache["delete"](key);
            }

            request = lastValueFrom(source, {
              defaultValue: false
            }); // 设置 原始 AjaxConfig

            _set(request, 'AjaxConfig', AjaxConfig); // 设置 缓存开始时间


            _set(request, 'CacheBeginTime', Date.now());

            AjaxBasics_1.Cache.set(key, request);
          }
        } else {
          request = lastValueFrom(source, {
            defaultValue: false
          });
        }

        return [2
        /*return*/
        , request["catch"](function (reason) {
          key && AjaxBasics_1.Cache["delete"](key);
          throw reason;
        })];
      });
    });
  };
  /**
   * ajax Observable
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.requestObservable = function (AjaxConfig) {
    var obs = of(_merge({}, AjaxBasics_1.defaultAjaxConfig, AjaxConfig)).pipe(map(AjaxBasics_1.queryParams), map(AjaxBasics_1.joinUrl), concatMap(AjaxBasics_1.merge), concatMap(function (value) {
      if (!_hasIn(value, 'headers.timestamp')) {
        _set(value, 'headers.timestamp', Date.now());
      }

      AjaxBasics_1.onStart(value);
      var obs = AjaxBasics_1.createAjax(value).pipe( // 错误处理
      catchError(function (err) {
        if (err instanceof Error && _isEmpty(_get(err, 'response'))) {
          AjaxBasics_1.ClearQueue(value);
          AjaxBasics_1.onError(err, value);
          AjaxBasics_1.onEnd(err, value);
          throw err;
        }

        return of(err);
      }), // 兼容小程序
      map(AjaxBasics_1.weappCompatible), // 过滤
      filter(AjaxBasics_1.filter(value)), // 转换数据
      map(AjaxBasics_1.map(value)));
      AjaxBasics_1.Queue.set(Encryption.MD5(value), obs);
      return obs;
    })); // lodash.set(obs, 'AjaxConfig', AjaxConfig)

    return obs;
  };
  /**
   * 获取 MD5 key
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.getMD5 = function (AjaxConfig) {
    AjaxConfig = _cloneDeep(AjaxConfig);

    _unset(AjaxConfig, 'headers.timestamp'); // 生成唯一Key


    return Encryption.MD5(AjaxConfig);
  };
  /**
   * ajax Observable
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.createAjax = function (AjaxConfig) {
    return ajax(AjaxConfig);
  };
  /**
   * 处理 get 请求 body 为 queryParams
   * @static
   * @param {IAjaxConfig} AjaxConfig
   * @return {*}
   * @memberof AjaxBasics
   */


  AjaxBasics.queryParams = function (AjaxConfig) {
    AjaxConfig.method = _toUpper(AjaxConfig.method);

    var isGet = _eq(AjaxConfig.method, 'GET');

    if (isGet && _isEmpty(AjaxConfig.queryParams)) {
      AjaxConfig.queryParams = _pickBy(AjaxConfig.body, function (x) {
        return !_includes([null, undefined, ''], x);
      });
    }

    return AjaxConfig;
  };
  /**
   * 处理 参数 地址Url
   * @param url 链接地址
   * @param params 参数
   * @returns 'url/{id}' {id:1} => 'url/1'
   */


  AjaxBasics.queryParamsToUrl = function (url, params) {
    var interpolate = /{([\s\S]+?)}/g;

    _uniq(url.match(interpolate)).map(function (par) {
      var key = _trimEnd(_trimStart(par, '{'), '}');

      var reg = new RegExp("(\\" + par + ")", 'g');
      url = _replace(url, reg, _get(params, key, ''));
    });

    return url;
  };
  /**
   * join url AjaxConfig.target+AjaxConfig.url
   * 转换 url 参数 test/{id}/{name} body:{id:1,name:2} > test/1/2
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.joinUrl = function (AjaxConfig) {
    // join target
    if (!Regulars.url.test(AjaxConfig.target) && !_includes(AjaxConfig.target, 'localhost')) {
      AjaxConfig.target = _join(_compact([AjaxBasics_1.defaultAjaxConfig.target, AjaxConfig.target]).map(function (str) {
        return _trim(str, '/');
      }), '/');
    } // join url


    if (!Regulars.url.test(AjaxConfig.url)) {
      AjaxConfig.url = _join(_compact([AjaxConfig.target, AjaxConfig.url]).map(function (str) {
        return _trim(str, '/');
      }), '/');
    }

    AjaxConfig.url = AjaxBasics_1.queryParamsToUrl(AjaxConfig.url, AjaxConfig.body);

    _unset(AjaxConfig, 'target');

    return AjaxConfig;
  };
  /**
   * merge AjaxConfig
   * 一般用于 等待 加入 用户或者校验 token
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.merge = function (AjaxConfig) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        // if (lodash.isFunction(AjaxConfig.merge)) {
        //     AjaxConfig = await AjaxConfig.merge(AjaxConfig)
        // }
        return [2
        /*return*/
        , AjaxConfig];
      });
    });
  };
  /**
   * 兼容小程序
   * @param res
   * @returns
   */


  AjaxBasics.weappCompatible = function (res) {
    // 兼容微信小程序
    if (_has(res, 'statusCode') && _has(res, 'errMsg')) {
      res = _assign({
        response: _get(res, 'data'),
        status: _get(res, 'statusCode'),
        responseHeaders: _get(res, 'header')
      }, res);
    } // 转换 字符串的 response 是否可以 json 序列化


    if (_isString(res.response)) {
      try {
        _set(res, 'response', JSON.parse(res.response));
      } catch (error) {
        console.warn('LENG ~ error', error);
      }
    }

    return res;
  };
  /**
   * 过滤请求结果
   * @param value
   * @returns
   */


  AjaxBasics.filter = function (AjaxConfig) {
    return function (res) {
      try {
        AjaxBasics_1.ClearQueue(AjaxConfig);
        AjaxBasics_1.onEnd(res, AjaxConfig);

        var response = _get(res, 'response');

        if ((res instanceof AjaxError || res instanceof TimeoutError) && _isEmpty(response)) {
          throw res;
        } // 自定义 状态码


        var statusKeys = _intersection(_keys(response), AjaxConfig.statusPath);

        if (_size(AjaxConfig.statusPath) && _size(statusKeys)) {
          var code = _get(response, _head(statusKeys));

          if (!_includes(AjaxConfig.successStatus, code)) {
            var messageKeys = _intersection(_keys(response), AjaxConfig.messagePath);

            if (_size(messageKeys)) {
              throw {
                message: _get(response, _head(messageKeys)),
                status: code
              };
            }

            throw res;
          }
        }

        return true;
      } catch (error) {
        AjaxBasics_1.onError(error, AjaxConfig);
        Log.error("\u3010" + _toUpper(AjaxConfig.method) + "\u3011Error - " + AjaxConfig.url, AjaxConfig, res); // return false

        throw error;
      }
    };
  };
  /**
   * 转换获取 请求数据
   * @param AjaxConfig
   * @returns
   */


  AjaxBasics.map = function (AjaxConfig) {
    return function (res) {
      // 执行 对应的状态码处理
      if (_has(AjaxBasics_1.statusMap, String(res.status))) {
        return _invoke(AjaxBasics_1.statusMap, String(res.status), res, AjaxConfig);
      }

      return res;
    };
  };
  /**
   * 清理队列
   * @param AjaxConfig
   */


  AjaxBasics.ClearQueue = function (AjaxConfig) {
    AjaxBasics_1.Queue["delete"](Encryption.MD5(AjaxConfig));

    _delay(function () {
      _eq(AjaxBasics_1.Queue.size, 0) && AjaxBasics_1.onEndAll();
    }, 100);
  };
  /**
   * 错误信息处理
   * @param error
   * @param AjaxConfig
   */


  AjaxBasics.onError = function (error, AjaxConfig) {// console.warn("LENG ~  onError", error, AjaxConfig)
  };
  /**
   * 开始
   * @param error
   * @param AjaxConfig
   */


  AjaxBasics.onStart = function (AjaxConfig) {// console.info("LENG ~  onStart", AjaxConfig)
  };
  /**
   * 结束
   * @param error
   * @param AjaxConfig
   */


  AjaxBasics.onEnd = function (response, AjaxConfig) {
    ENV_TEST && Log.success("\u3010 Ajax End \u3011", response);
  };
  /**
   * 全部 请求 结束 请求队列清空
   */


  AjaxBasics.onEndAll = function () {};

  var AjaxBasics_1;
  /**
   * 全局默认 AjaxConfig
   * @type {IAjaxConfig}
   * @memberof AjaxBasics
   */

  AjaxBasics.defaultAjaxConfig = {
    method: 'get',
    target: '/',
    timeout: 30000,
    successStatus: [200, '00000'],
    headers: {}
  };
  /**
   * 请求队列
   * @static
   * @memberof AjaxBasics
   */

  AjaxBasics.Queue = new Map();
  /**
   * 缓存队列
   * @static
   */

  AjaxBasics.Cache = new Map();
  /**
   * 缓存时长
   */

  AjaxBasics.CacheTime = 60000;
  /**
   * 状态码处理
   * @static
   * @memberof AjaxBasics
   */

  AjaxBasics.statusMap = {
    /** status = 200 */
    '200': function _(value, AjaxConfig) {
      // 自定义 response 数据集
      var responseKeys = _intersection(_keys(value.response), AjaxConfig.responsePath);

      if (_size(AjaxConfig.responsePath) && _size(responseKeys)) {
        return _get(value.response, _head(responseKeys));
      }

      if (_eq(_toLower(AjaxConfig.responseType), 'blob')) {
        return value;
      }

      return value.response;
    }
  };
  AjaxBasics = AjaxBasics_1 = __decorate([BindAll()], AjaxBasics);
  return AjaxBasics;
}();
// interface SuccessCallbackResult<T extends string | ArrayBuffer = any | any> extends CallbackResult {
//     /** 开发者服务器返回的数据 */
//     data: T
//     /** 开发者服务器返回的 HTTP Response Header */
//     header: any
//     /** 开发者服务器返回的 HTTP 状态码 */
//     statusCode: number
//     /** 调用结果 */
//     errMsg: string
//     /** cookies */
//     cookies?: string[]
// }
// interface CallbackResult {
//     /** 错误信息 */
//     errMsg: string
// }

export { AjaxBasics };
//# sourceMappingURL=ajaxBasics.js.map
